/**
 * Consent Manager - Manages consent preferences with default granted state
 * Implements Google Consent Mode v2 and Shopify Customer Privacy API
 */

(function() {
  'use strict';

  // Initialize dataLayer for Google Consent Mode
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  // Check if banner should be shown to determine default consent state
  // If banner should NOT be shown (shouldShowBanner() === false), default to granted
  // If banner SHOULD be shown (shouldShowBanner() === true), default to denied
  const shouldShowBanner = window.Shopify && 
                            window.Shopify.customerPrivacy && 
                            typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function' 
                            ? window.Shopify.customerPrivacy.shouldShowBanner() 
                            : false;
  
  const defaultConsentState = shouldShowBanner ? 'denied' : 'granted';

  // Set default consent state based on banner visibility
  // This must run BEFORE any tracking scripts load
  gtag('consent', 'default', {
    'ad_storage': defaultConsentState,
    'ad_user_data': defaultConsentState,
    'ad_personalization': defaultConsentState,
    'analytics_storage': defaultConsentState,
    'functionality_storage': defaultConsentState,
    'personalization_storage': defaultConsentState,
    'security_storage': 'granted', // Always granted
    'wait_for_update': 500 // Wait for consent banner (milliseconds)
  });

  // Configure additional settings for privacy
  gtag('set', 'ads_data_redaction', true);
  gtag('set', 'url_passthrough', true);
  
  // Enable debug mode (for testing)
  // Remove or disable in production if needed
  if (window.location.hostname.includes('myshopify.com') || window.location.hostname === 'localhost') {
    gtag('set', 'developer_id.dZGIwZj', true);
    console.log('Google Consent Mode debug mode enabled');
  }

  // Consent state management
  // Initialize with default based on banner visibility
  const initialConsentState = !shouldShowBanner; // true if no banner, false if banner shown
  
  window.ConsentManager = {
    consentState: {
      analytics: initialConsentState,
      marketing: initialConsentState,
      preferences: initialConsentState,
      required: true
    },

    // Check if consent has been granted for a specific category
    hasConsent: function(category) {
      if (category === 'required') return true;
      return this.consentState[category] === true;
    },

    // Update consent state and Google Consent Mode
    updateConsent: function(consent) {
      this.consentState = {
        analytics: consent.analytics || false,
        marketing: consent.marketing || false,
        preferences: consent.preferences || false,
        required: true
      };

      // Update Google Consent Mode
      if (typeof gtag !== 'undefined') {
        gtag('consent', 'update', {
          'analytics_storage': consent.analytics ? 'granted' : 'denied',
          'ad_storage': consent.marketing ? 'granted' : 'denied',
          'ad_user_data': consent.marketing ? 'granted' : 'denied',
          'ad_personalization': consent.marketing ? 'granted' : 'denied',
          'functionality_storage': consent.preferences ? 'granted' : 'denied',
          'personalization_storage': consent.preferences ? 'granted' : 'denied'
        });
      }

      // Store consent in localStorage
      try {
        localStorage.setItem('consent_preferences', JSON.stringify({
          ...this.consentState,
          timestamp: Date.now()
        }));
      } catch (e) {
        console.warn('Could not save consent preferences:', e);
      }

      // Dispatch event for other scripts
      document.dispatchEvent(new CustomEvent('consentUpdated', {
        detail: this.consentState
      }));
    },

    // Load consent from localStorage on page load
    loadStoredConsent: function() {
      try {
        const stored = localStorage.getItem('consent_preferences');
        if (stored) {
          const consent = JSON.parse(stored);
          // Only use if less than 1 year old
          if (consent.timestamp && (Date.now() - consent.timestamp) < 31536000000) {
            this.updateConsent({
              analytics: consent.analytics !== undefined ? consent.analytics : initialConsentState,
              marketing: consent.marketing !== undefined ? consent.marketing : initialConsentState,
              preferences: consent.preferences !== undefined ? consent.preferences : initialConsentState
            });
            return true;
          }
        }
        // If no stored consent, use default based on banner visibility
        // If banner should NOT be shown, default to granted (true)
        // If banner SHOULD be shown, default to denied (false)
        this.updateConsent({
          analytics: initialConsentState,
          marketing: initialConsentState,
          preferences: initialConsentState
        });
        return true;
      } catch (e) {
        console.warn('Could not load stored consent:', e);
        // On error, use default based on banner visibility
        this.updateConsent({
          analytics: initialConsentState,
          marketing: initialConsentState,
          preferences: initialConsentState
        });
        return true;
      }
    }
  };

  // Load stored consent immediately
  window.ConsentManager.loadStoredConsent();

  // Helper function to check consent before loading scripts
  window.loadScriptWithConsent = function(category, scriptLoader) {
    if (window.ConsentManager.hasConsent(category)) {
      scriptLoader();
    } else {
      // Wait for consent
      document.addEventListener('consentUpdated', function handler(e) {
        if (window.ConsentManager.hasConsent(category)) {
          scriptLoader();
          document.removeEventListener('consentUpdated', handler);
        }
      });
    }
  };

})();
